import ChargerPage from "./ChargerPage";

export default ChargerPage